/* eslint-disable react/prop-types */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-tabs */
import { Button } from '@ui5/webcomponents-react';
import { NotificationListItem } from '@ui5/webcomponents-react';
import { Priority } from '@ui5/webcomponents-react';
import eureka from 'eureka';
import React from 'react';
import { createUseStyles } from 'react-jss';
import history from '../../common/history';
import dayjs from 'dayjs';
import i18next from 'i18next';

/**
Range	Key	Sample Output
0 to 44 seconds	s	a few seconds ago
unset	ss	44 seconds ago
45 to 89 seconds	m	a minute ago
90 seconds to 44 minutes	mm	2 minutes ago ... 44 minutes ago
45 to 89 minutes	h	an hour ago
90 minutes to 21 hours	hh	2 hours ago ... 21 hours ago
22 to 35 hours	d	a day ago
36 hours to 25 days	dd	2 days ago ... 25 days ago
26 to 45 days	M	a month ago
45 to 319 days	MM	2 months ago ... 10 months ago
320 to 547 days (1.5 years)	y	a year ago
548 days+	yy	2 years ago ... 20 years ago
 */

const { useTranslation, i18n } = eureka.I18nProvider;
// const { fromUtcToZone } = eureka.DateManager;
const buttonStyle = {
  margin: '3px',
};
const Second = 1000;
const Minute = 60 * Second;
const Hour = 60 * Minute;
const Day = 24 * Hour;
const Year = 365 * Day;
const useStyles = createUseStyles({
  notificationStyle: {
    width: '400px',
    marginTop: '4px',
    marginBottom: '4px',
    borderRadius: '0.25rem',
    boxShadow: 'var(--sapContent_Shadow0)',
    '& > div > div': {
      boxShadow: 'none',
    },
  },
  negative: {
    '--sapSuccessBorderColor': 'red',
  },
  wrapper: {
    display: 'flex',
  },
  contentWrapper: {
    width: '301px',
    marginBottom: '-20px',
  },
  content: {
    marginTop: '20px',
    whiteSpace: 'normal',
    color: 'var(--sapContent_LabelColor)',
  },
  footer: {
    textAlign: 'right',
    marginRight: '-48px',
  },
  indicator: {
    display: 'inline-block',
    margin: '4px 0',
    borderRadius: '0.25rem 0 0 0.25rem',
    width: '0.375rem',
    minWidth: '0.375rem',
    backgroundColor: 'var(--sapSuccessBorderColor)',
  },
  indicatorError: {
    display: 'inline-block',
    margin: '4px 0',
    borderRadius: '0.25rem 0 0 0.25rem',
    width: '0.375rem',
    minWidth: '0.375rem',
    backgroundColor: 'var(--sapErrorBorderColor)',
  },
});

export const reviewDocumentUpload = (notification, onCloseFunction) => {
  history.push(`/excel-extraction/${notification.data.businessObject.split('::')[1]}`);
  onCloseFunction(notification);
};

export const reviewApproval = (approvalId, claimId, onCloseFunction, notification) => {
  history.push(`/claims/details/${claimId}/approvals/${approvalId}`);
  onCloseFunction(notification);
};

export const viewDocumentDetail = (documentId, onCloseFunction, notification) => {
  history.push(`/document-library/details/${documentId}`);
  onCloseFunction(notification);
};
export const parseBusinessObject = (notification) => {
  let fileName;
  let documentId;
  try {
    fileName = JSON.parse(notification.data.businessObject).originalFileName;
    documentId = JSON.parse(notification.data.businessObject).documentId;
  } catch {
    fileName = '';
    documentId = '';
  }
  return { fileName, documentId };
};

const NOTIFICATION_TYPE = {
  ACTIVATE_ALT: {
    name: 'ACTIVATE_ALT',
    urlMappingBasedOnBusinessObject: {
      ACTIVITY_LIST_TEMPLATE: (id) => `/alt/view/${id}`,
    },
  },
  ADD_ATTACHMENT: {
    name: 'ADD_ATTACHMENT',
    urlMappingBasedOnBusinessObject: {
      ACTIVITY_TEMPLATE: () => `/libraries/activities`,
      ACTIVITY_TEMPLATE_LIST: (id) => `/alt/view/${id}`,
    },
  },
  ADD_PLANOGRAM: {
    name: 'ADD_PLANOGRAM',
    urlMappingBasedOnBusinessObject: {
      ACCOUNT: () => `/customers/accounts`,
    },
  },
};

function getIdAndResult(notification = '') {
  // "changeResult": "SUCCESS"
  // "changeResult": "SUCCESS,940,68DA3AC2278640CD8F9B0C2A76D8356C"
  // "changeResult": "result,planNo,bizId"
  const [resultAsStr, id] = notification?.data?.changeResult?.split(',') || [];
  const urlMapping =
    NOTIFICATION_TYPE[notification?.data?.changeAction]?.urlMappingBasedOnBusinessObject || {};
  const viewButtonURL = id ? urlMapping[notification?.data?.businessObject]?.(id) : '';
  return {
    isSuccess: ['Done', 'DONE', 'SUCCESS'].includes(resultAsStr),
    viewButtonURL,
    id,
  };
}

export default function CustomNotification({ notification, onCloseFunction, settings }) {
  try {
    // This code fails in UT, so let's catch it.
    dayjs.updateLocale(dayjs.locale(), {
      relativeTime: {
        future: '%s',
        past: '%s',
        s: i18next.t('aFewSecondsAgo', 'a few seconds ago', { type: 'act', desc: '' }),
        m: i18next.t('aMinuteAgo', 'a minute ago', { type: 'act', desc: '' }),
        mm: i18next.t('minutesAgo', '%d minutes ago', { type: 'act', desc: '' }),
        h: i18next.t('anHourAgo', 'an hour ago', { type: 'act', desc: '' }),
        hh: i18next.t('hoursAgo', '%d hours ago', { type: 'act', desc: '' }),
        d: i18next.t('aDayAgo', 'a day ago', { type: 'act', desc: '' }),
        dd: i18next.t('daysAgo', '%d days ago', { type: 'act', desc: '' }),
        M: i18next.t('aMonthAgo', 'a month ago', { type: 'act', desc: '' }),
        MM: i18next.t('monthsAgo', '%d months ago', { type: 'act', desc: '' }),
        y: i18next.t('aYearAgo', 'a year ago', { type: 'act', desc: '' }),
        yy: i18next.t('yearsAgo', '%d years ago', { type: 'act', desc: '' }),
      },
    });
  } catch (e) {}

  const { t } = useTranslation();
  const classes = useStyles();

  const fromNow = dayjs(notification.receivedTime).fromNow();

  const datetime = (
    <div style={{ marginTop: '5px', color: 'var(--sapContent_LabelColor)' }}>{fromNow}</div>
  );
  if (notification?.data?.businessObject?.startsWith('USER_MANAGEMENT_RESPONSIBILITIES')) {
    return (
      <div className={classes.wrapper}>
        <div className={classes.indicator} />
        <NotificationListItem
          className={classes.notificationStyle}
          heading={t('Notification_Responsibilities')}
          footnotes={datetime}
          priority={Priority.Low}
          showClose
          onClose={() => onCloseFunction(notification)}
          wrap
          read={false}
        >
          <div className={classes.contentWrapper}>
            <div className={classes.content}>{notification.data.message}</div>
            <div className={classes.footer}>
              <div style={{ height: '34px' }} design="Positive" />
            </div>
          </div>
        </NotificationListItem>
      </div>
    );
  }

  const { isSuccess, viewButtonURL } = getIdAndResult(notification);
  const i18nHeading = `${notification?.data?.changeAction ?? ''}_${
    isSuccess ? 'SUCCESS' : 'FAILED'
  }`;

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.indicator} ${isSuccess ? '' : classes.negative}`} />
      <NotificationListItem
        className={classes.notificationStyle}
        titleText={i18n.exists(i18nHeading) ? t(i18nHeading) : t('Notification_Other')}
        priority={isSuccess ? Priority.Low : Priority.High}
        showClose
        onClose={() => onCloseFunction(notification)}
        wrappingType="Normal"
        read={false}
      >
        <div className={classes.contentWrapper}>
          <div className={classes.content}>{notification.data.message}</div>
          {datetime}
          <div className={classes.footer}>
            <Button
              onClick={() => {
                history.push(viewButtonURL);
              }}
              style={buttonStyle}
              design="Positive"
              data-testid="notification-view-button"
              disabled={viewButtonURL == ''}
            >
              {t('Notification_ViewBtn')}
            </Button>
          </div>
        </div>
      </NotificationListItem>
    </div>
  );
}
